import {
  getList,
  LeoUUID,
} from "@surya-digital/leo-ts-types";

export interface GroupQuestionV1DTO {
  childQuestionIds: string[];
}

export class GroupQuestionV1 {
  readonly isGroupQuestionV1GroupQuestionV1: boolean = true;

  readonly childQuestionIds: LeoUUID[];

  static readonly constraints = {
    "childQuestionIds": {
      "maxSize": 16,
    }
  }

  constructor(
  childQuestionIds: LeoUUID[]
  ) {
    GroupQuestionV1.validateChildQuestionIds(childQuestionIds);
    this.childQuestionIds = childQuestionIds;
  }

  static fromDTO(dto: GroupQuestionV1DTO): GroupQuestionV1 {
    const childQuestionIds = getList<string, LeoUUID>(
      dto,
      "childQuestionIds",
      (e: string) => new LeoUUID(e),
      InvalidGroupQuestionV1ChildQuestionIdsError
    );
    return new GroupQuestionV1(
      childQuestionIds
    );
  }

  toDTO(): GroupQuestionV1DTO {
    const dto: GroupQuestionV1DTO = {
        childQuestionIds: this.childQuestionIds.map((e: LeoUUID) => { return e.toDTO(); })
    };
    return dto;
  }
  private static validateChildQuestionIds = (childQuestionIds: LeoUUID[]): void => {
    if(childQuestionIds.length > 16) {
      throw new InvalidGroupQuestionV1ChildQuestionIdsMaxSizeError(
        16,
        `Attribute childQuestionIds is too long. Size is ${childQuestionIds.length}. Max size is 16.`
      );
    }
  }
  
}

GroupQuestionV1.prototype.toString = function toString(): string {
  return `GroupQuestionV1(childQuestionIds='${this.childQuestionIds}')`;
};

export class InvalidGroupQuestionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupQuestionV1Error";
  }
}
export class InvalidGroupQuestionV1ChildQuestionIdsError extends InvalidGroupQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupQuestionV1ChildQuestionIdsError";
  }
}

export class InvalidGroupQuestionV1ChildQuestionIdsMaxSizeError extends InvalidGroupQuestionV1ChildQuestionIdsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGroupQuestionV1ChildQuestionIdsMaxSizeError";
  }
}
